import { Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { VisualizationAttr } from "../../../../CommonElements";

const GroupStafDetail = ({ data, isOpen, toggle }) => {
  const ASAL_ABSENSI = {
    1: "Fingerprint",
    2: "Satpam",
    3: "Fingerprint dan Satpam",
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size={"lg"}>
      <ModalHeader toggle={toggle}>
        <Label>Detail Group Staff</Label>
      </ModalHeader>
      <ModalBody className={"row row-cols-4"}>
        {data && (
          <>
            <VisualizationAttr
              className={"col-6"}
              label={"Nama Group"}
              content={data.nama}
            />
            <VisualizationAttr label={"ID Group"} content={data.id_group} />
            <VisualizationAttr label={"Max Cuti"} content={data.max_cuti} />
            <VisualizationAttr
              className={"col-6"}
              label={"DPSJ"}
              content={data.id_unit_kerja}
            />
            <VisualizationAttr label={"Jam Masuk"} content={data.jam_masuk} />
            <VisualizationAttr label={"Jam Keluar"} content={data.jam_keluar} />
            <VisualizationAttr
              className={"col-6"}
              label={"Pimpinan"}
              content={data.pimpinan}
            />
            <VisualizationAttr
              className={"col-6"}
              label={"Email Pimpinan"}
              content={data.email_pimpinan}
            />
            <VisualizationAttr
              label={"Asal Absensi"}
              content={ASAL_ABSENSI[data.asal_absensi]}
            />
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default GroupStafDetail;
